import React, { useEffect, useCallback, useMemo, useState } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { JobService } from "../../Network/services/JobService";
import { contractService } from "../../Network/services/contractService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { commonService } from "../../Network/services/commonService";
import Modal from "react-modal";
import GoogleMapReact from "google-map-react";
import NewWindow from 'react-new-window'
import PaymentScreen from "./PaymentScreen";
import { render, createPortal } from "react-dom";
import { Rating } from 'react-simple-star-rating'
import "./MilestoneCards.css"
import TermFinishedIcon from "../../assets/images/TermFinsihedIcon.svg";
import ProfilePopup from "../ProfilePopup";
import FilePreview from "../FilePreview";

const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const MarkerComponent = ({ text }) => (
  <div style={{ 
  position: 'absolute',
  transform: 'translate(-50%, -100%)',
  zIndex: 1000
}}>
  <div style={{
    width: 30,
    height: 30,
    backgroundColor: '#F57E1F',
    border: '3px solid white',
    borderRadius: '50% 50% 50% 0',
    transform: 'rotate(-45deg)',
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }}>
    <div style={{
      transform: 'rotate(45deg)',
      color: 'white',
      fontSize: '12px',
      fontWeight: 'bold',
      width: '8px',
      height: '8px',
      backgroundColor: 'white',
      borderRadius: '50%'
    }}>
    </div>
  </div>
</div>
);

const AwardedJobDetailView = (props) => {
  let location = useLocation();
  let history = useHistory();

  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [ord_id, setOrd_id] = useState("");
  const [mapView, setMapView] = useState(false);
  const [jobData, setJobData] = useState(null);
  const [isOpen, setOpenState] = useState(false);
  const open = useCallback(() => setOpenState(true));
  const close = useCallback(() => setOpenState(false));
  const [newWindow, setNewWindow] = useState();
  const [msgPopup, setMsgPopup] = useState(false);
  const [mobile, setMobile] = useState("");
  const [ratingView, setRatingView] = useState(false);
  const [selectedRating, setSelectedRating] = useState(0);
  const [comment, setComment] = useState("");
  const [rating, setRating] = useState(0) // initial rating value
  const [jobID, setJobID] = useState("");
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState(null);
  var countdown;
  let check = ""

  useEffect(() => {
    if (location.state?.item?.id) {
      fetchUpdatedJobData(location.state.item.id, true);
      setJobID(location.state.item.id);
    } else {
      const urlParams = new URLSearchParams(location.search);

      const orderId = urlParams.get('order_id');
      const jobID = urlParams.get('jobID');
      if (jobID) {
        fetchUpdatedJobData(jobID, true);
        setJobID(jobID);
      }
      else {
        const pathParts = window.location.pathname.split('/');
        const job_id = pathParts[pathParts.length - 1]; 
        
        if (job_id && !isNaN(job_id)) {
          fetchUpdatedJobData(job_id, true);
          setJobID(job_id);
        }
      }
       if (orderId) {
         setOrd_id(orderId);
         window.history.replaceState({}, document.title, window.location.pathname);
       }
    }
  }, []);
  let back = (e) => {
    e.preventDefault();
    window.location.href = "/mycontracts";
  };

  useEffect(() => {
  const fetchJobData = async () => {
    if (location.state?.item?.id) {
      const jobId = location.state.item.id;
      setJobID(jobId);
      
      await fetchUpdatedJobData(jobId, true);
      
      const jobDetails = await fetchSingleJobDetails(jobId);
      
      if (jobDetails) {
        setJobData(prevData => ({
          ...prevData,
          ...jobDetails,
          ratings: jobDetails.ratings,
          is_completed: jobDetails.is_completed
        }));
      }
    } else {
      const urlParams = new URLSearchParams(location.search);
      const orderId = urlParams.get('order_id');
      const jobID = urlParams.get('jobID');

      if (jobID) {
        setJobID(jobID);
        await fetchUpdatedJobData(jobID, true);
        
        const jobDetails = await fetchSingleJobDetails(jobID);
        if (jobDetails) {
          setJobData(prevData => ({
            ...prevData,
            ...jobDetails,
            ratings: jobDetails.ratings,
            is_completed: jobDetails.is_completed
          }));
        }
      } else {
        const pathParts = window.location.pathname.split('/');
        const job_id = pathParts[pathParts.length - 1]; 
        
        if (job_id && !isNaN(job_id)) {
          setJobID(job_id);
          await fetchUpdatedJobData(job_id, true);
          
          const jobDetails = await fetchSingleJobDetails(job_id);
          if (jobDetails) {
            setJobData(prevData => ({
              ...prevData,
              ...jobDetails,
              ratings: jobDetails.ratings,
            }));
          }
        }
      }
      
      if (orderId) {
        setOrd_id(orderId);
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
  };

  fetchJobData();
}, []);

  const toggleModel = () => {
    setOpenSharejob(!openShareJob);
  };

  const INTERVAL_DELAY = 1000;

  const startPaymentStatus = () => {
  };

  const openInNewTab = (url) => {
     newWindow = window.open(url)
  }



const handleRating = (rate) => {
  const finalRate = Math.max(1, rate);
  setSelectedRating(finalRate);
  
  if (!ratingView) {
    setRatingView(true);
  }
};

  const handleProfileIconClick = (userData) => {
    setSelectedUserData(userData);
    setShowProfilePopup(true);
  }

  const closeProfilePopup = () => {
    setShowProfilePopup(false);
    setSelectedUserData(null);
  }

  const NewWindow = ({ children, close }) => {
    const newWindow1 = useMemo(() =>
      window.open(
        "about:blank",
        "newWin",
        `width=400,height=300,left=${window.screen.availWidth / 2 -
          200},top=${window.screen.availHeight / 2 - 150}`
      )
    );
    newWindow1.onbeforeunload = () => {
      close();
    };
    useEffect(() => () => newWindow1.close());
    return createPortal(children, newWindow1.document.body);
  };
  useEffect(() => {
    if (ord_id != "") {
    }
  }, [ord_id]);

  useEffect(() => {
    if (jobData?.user_rating !== undefined && jobData?.user_rating !== null) {
      const ratingValue = parseInt(jobData.user_rating, 10);
      const finalRating = isNaN(ratingValue) ? 0 : ratingValue;
      setRating(finalRating);
    } else {
      setRating(0);
    }
  }, [jobData]);

  const checkRatingConditionOnly = useCallback(async (jobId) => {
    try {
      const form = new FormData();
      const token = window.localStorage.getItem("auth_token");
      form.append("auth_token", token);
      form.append("job_id", jobId);

      const response = await commonService.CommonService("get_single_job", form);
      
      if (response.status === "200" && response.data && response.data.length > 0) {
        const jobDetails = response.data[0];
        
        if (jobDetails.is_completed === "Completed" && 
            jobDetails.employee_details?.ratings?.is_employee_rated === false) {
          setRatingView(true);
          setSelectedRating(0);
          return true;
        }
        
        return false;
      }
      
      return false;
    } catch (error) {
      console.error("Error checking rating condition:", error);
      return false;
    }
  }, []);

  useEffect(() => {
    const checkRatingCondition = async () => {
      if (!jobData?.id || ratingView || initialLoading) {
        return; // Don't check if no job data, popup is already open, or still initial loading
      }

      if (jobData?.completed_status === "Completed" || jobData?.is_completed === "Completed") {
        await checkRatingConditionOnly(jobData.id);
      }
    };

    if (jobData && !initialLoading) {
      checkRatingCondition();
    }
  }, [jobData?.id, jobData?.completed_status, jobData?.is_completed, ratingView, initialLoading, checkRatingConditionOnly]);

  const fetchSingleJobDetails = async (jobId) => {
  try {
    setLoading(true);
    const form = new FormData();
    const token = window.localStorage.getItem("auth_token");
    form.append("auth_token", token);
    form.append("job_id", jobId);

    const response = await commonService.CommonService("get_single_job", form);
    
    if (response.status === "200" && response.data && response.data.length > 0) {
      const jobDetails = response.data[0];
      
      // Check if we need to show rating popup
      if (jobDetails.is_completed === "Completed" && 
          jobDetails.employee_details?.ratings?.is_employee_rated === false) {
        // Auto-open rating popup
        setRatingView(true);
        setSelectedRating(0); 
      }
      
      return jobDetails;
    }
    
    return null;
  } catch (error) {
    console.error("Error fetching single job details:", error);
    return null;
  } finally {
    setLoading(false);
  }
};


const ratingCall = (rate, comment) => {
  setLoading(true);
  const form = new FormData();
  form.append("user_rating", rate);
  form.append("user_id", jobData?.awarded_to_user_id);
  form.append("job_id", jobData?.id || jobID);
  form.append("user_comment", comment);

  commonService
    .CommonService("leave_rating", form)
    .then(async (res) => {
      if (res.status == 200) {
        toast.success(res.message, {
          position: "top-right",
          type: "success",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
        
        setRatingView(false);
        setRating(rate);
        setComment("");
        setSelectedRating(0);
        
        if (jobID) {
          await fetchSingleJobDetails(jobID);
          await fetchUpdatedJobData(jobID);
        }
      } else {
        toast.error(res.message, {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      }
    })
    .catch((err) => {
      toast.error(err.message, {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    })
    .finally(() => {
      setLoading(false);
    });
};


const handleSubmit = () => {
  if (selectedRating > 0) {
    ratingCall(selectedRating, comment);
  } else {
    toast.error('Please select a rating', {
      position: "top-right",
      type: "error",
      autoClose: 3000,
    });
  }
};

const handleClosePopup = () => {
  setRatingView(false);
  setComment("");
};

  useEffect(() => {
    if(ord_id){
      paymentStatus();
    }
  },[ord_id]);


  const paymentStatus = () => {
    setLoading(true);
    const form = new FormData();
    form.append("order_id", ord_id);

    commonService
      .CommonService("escrow_payment_status", form)
      .then(async (res) => {
        if (res.status == 200) {
          if (res.payment_status == "SUCCESS") {
            clearInterval(countdown);
            toast.success(res.message, {
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
            await fetchUpdatedJobData(jobID);
          } else if (res.payment_status == "PENDING" || res.payment_status == "NOT_ATTEMPTED") {
           
          
          } else {
            await fetchUpdatedJobData(jobID);


            toast.success(res.message, {
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
          }

        } else {
          clearInterval(countdown);
            await fetchUpdatedJobData(jobID);

          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        clearInterval(countdown);

        toast.success(err.message, {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const fetchUpdatedJobData = async (jobId = jobID, isInitialLoad = false) => {
    try {
      if (isInitialLoad) {
        setInitialLoading(true);
      } else {
        setLoading(true);
      }
      const payload = new FormData();
      payload.append("job_id", jobId);
      const response = await JobService.getJobById(jobId);
      if (response.status === "200" && response.data && response.data.length > 0) {
        const apiData = response.data[0];
        const fallbackData = location.state?.item || {};
        
        const mergedData = {
          ...fallbackData, 
          ...apiData,    
          id: apiData.id,
          job_unique_id: apiData.job_unique_id,
          job_title: apiData.job_title,
          job_description: apiData.job_description,
          amount: apiData.amount,
          status: apiData.status,
          completed_status: apiData.completed_status,
          awarded_to_quote_id: apiData.awarded_to_quote_id,
          payment_milestone: apiData.payment_milestone || fallbackData.payment_milestone,
          user_rating: apiData.user_rating || fallbackData.user_rating || 0
        };
        
      
        
        setJobData(mergedData);
        return mergedData;
      } else {
        toast.error(response.message || "Failed to fetch updated job data", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
        if (isInitialLoad) {
          history.goBack();
        }
      }
    } catch (error) {
      console.error("Error fetching updated job data:", error);
      toast.error("Something went wrong while fetching job data. Please try again.", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      if (isInitialLoad) {
        history.goBack();
      }
    } finally {
      if (isInitialLoad) {
        setInitialLoading(false);
      } else {
        setLoading(false);
      }
    }
    return null;
  };

  const updateStatus = (id, milestone, status, amount, milestone_id = null) => {
    setLoading(true);
    const form = new FormData();
    form.append("milestone", milestone);
    form.append("milestone_status", status);
    form.append("job_id", id);
    if (amount != "") {
      form.append("amount", amount);
    }
    if (milestone_id != null) {
      form.append("milestone_id", milestone_id);
      form.append("employer_status", status);
      form.append("quote_id", jobData?.awarded_to_quote_id);
    }

    commonService
      .CommonService("mark_as_completed", form)
      .then(async (res) => {
        if (res.status == 200) {
          if (status == "Completed" && res.payment_link != "") {

            setOrd_id(res.order_id);
            if(res.payment_link != ""){
              window.location.href = res.payment_link;
            }
            
          } else {
            toast.success(res.message, {
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
            await fetchUpdatedJobData(id);

          }

        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
      })
      .finally(() => {
       setTimeout(() => {
        setLoading(false);
       }, 2000);
      });
  };

  if (initialLoading) {
    return (
      <section className="explore explore1">
        <div className="container">
          <div className="banner">
            <div className="row">
              <div className="col-md-4">
                <div className="breadcrumps">
                  <ul>
                    <li>
                      <div onClick={back}>
                        <a href="#">
                          <i className="bx bx-chevron-left" /> Back to Jobs I posted
                        </a>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="explore-details">
            <div className="row">
              <div className="col-md-12 text-center">
                <LoadingOverlay>
                  <Loader loading={true} />
                </LoadingOverlay>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  if (!jobData) {
    history.goBack();
    return null;
  }

const getRatingLabel = (rating) => {
  const labels = {
    1: 'Unsatisfactory',
    2: 'Below Average',
    3: 'Average',
    4: 'Good',
    5: 'Excellent'
  };
  return labels[rating] || '';
};

  return (
    <section className="explore explore1">
      <div className="container">
        <div className="banner">
          <div className="row">
            <div className="col-md-6">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <div onClick={back}>
                      <a href="#">
                        <i className="bx bx-chevron-left" /> Back to Jobs I posted
                      </a>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="explore-details">
          <div className="row">
            <div className="col-md-7">
              <p className="jobid">
                Job#{" "}
                <span>
                  {jobData?.job_unique_id?.substr(
                    jobData?.job_unique_id?.indexOf(" ") + 1
                  )}
                </span>
              </p>
              
              <h1 className="title">{jobData?.job_title}</h1>
              
              <ul className="list-two">
                <li>
                  <a href="#!">
                    {jobData?.job_location} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!">
                    {jobData?.bid_payment_term} <span>|</span>
                  </a>
                </li>
                <li>
                  <a href="#!" />
                  Posted {jobData?.timestamp} <span>|</span>
                </li>
                <li>
                  <a href="#!">
                    Targeted close date {jobData?.target_closed_date}{" "}
                    <span>|</span>
                  </a>
                </li>
                {/* <li>
                  <a href="#!">
                    {jobData?.total_quote_count} Quotes Received
                  </a>
                </li> */}
              </ul>
              
              <p className="job-details-label quote-detail-job-label-no-margin">Project Budget</p>
              <div className="payment-amount">
                ₹{jobData?.amount}
              </div>
              
              <p className="job-details-label">Category</p>
              <div className="job-category">
                {jobData?.parent_category_name && jobData?.category_full_name
                  ? `${jobData.parent_category_name} > ${jobData.category_full_name}`
                  : jobData?.category_full_name || jobData?.category || 'General'}
              </div>
              
              {jobData?.skills && (
                <>
                  <p className="job-details-label">Required Skills</p>
                  <ul className="category-list">
                    {jobData.skills.split(',').map((skill, index) => (
                      <li key={index} className="skill-tag">
                        {skill.trim()}
                      </li>
                    ))}
                  </ul>
                </>
              )}
              
              <p className="job-details-label quote-detail-job-label-no-margin">About Job</p>
              <p>{jobData?.job_description}</p>
              
              {jobData?.attach_file && jobData.attach_file.length > 0 && (
                <>
                  <p className="job-details-label">Attachments</p>
                  <div className="form-group myresume-file-preview-container">
                    {jobData.attach_file.split(",").map((file, index) => (
                      <FilePreview key={index} fileUrl={file.trim()} />
                    ))}
                  </div>
                </>
              )}

            </div>
            <div className="col-md-5">
              <section className="profile you-quoted share status">
                <LoadingOverlay>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-6 padding-0">
                        <h3>Job Status</h3>
                      </div>
                      {jobData?.contact_flag == '1' ? (
                      <div className="col-md-6 padding-0">
                        <a href="#" className="message" onClick={(e)=>{
                          e.preventDefault();
                          setMobile(jobData?.employee_mobile);
                          setMsgPopup(true);
                        }}>
                          <img src="/assets/images/message.png" /> Message
                        </a>
                      </div>  ) : null}
                    </div>

                    <div className="row">
          <div className="col-md-12 padding-0">
            <h3>Job Awarded to</h3>
          </div>
        </div>
        <div className="profile-detail yorself awarded">
          <div className="row">
            <div className="col-md-12 padding-0">
                <a href={`/user-detail/${jobData?.employee_details?.id}`} className="profile-avatar">
              
                {jobData?.employee_details?.profile_image && jobData?.employee_details?.profile_image !== "" ? (
                    <img src={`${jobData?.employee_details?.profile_image.includes("https://") ? jobData?.employee_details?.profile_image : `${process.env.REACT_APP_BACKEND_BASE_URL}/${jobData?.employee_details?.profile_image}`}`} />
                  ) : (
                    <img src="/assets/images/profile-avatar.png"  />
                  )}
                </a>
              <ul style={{width: '100%'}}>
                <li style={{width: '100%', paddingRight: '0px'}}>
                  <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                    <a href={`/user-detail/${jobData?.employee_details?.id}`} >
                      <h3 style={{marginBottom: '10px'}}>{jobData?.employee_details?.name || `${jobData?.employee_details?.first_name || ''} ${jobData?.employee_details?.last_name || ''}`.trim()}</h3>
                    </a>
                    <div
                      className="profile-icon"
                      onClick={() => handleProfileIconClick({
                        user_id: jobData?.employee_details?.id,
                        user_name: jobData?.employee_details?.name || `${jobData?.employee_details?.first_name || ''} ${jobData?.employee_details?.last_name || ''}`.trim(),
                        profile_image: jobData?.employee_details?.profile_image,
                        job_location: jobData?.employee_details?.location,
                        employee_mobile: jobData?.employee_details?.mobile_number,
                        user_rating: jobData?.employee_details?.ratings?.employee_rating,
                        no_of_people_reviewed: jobData?.employee_details?.ratings?.rated_by_count
                      })}
                      style={{ cursor: 'pointer' }}
                    >
                      <img src="/assets/images/userProfileInfoIcon.svg" alt="Profile Info" style={{marginBottom: '0px'}}/>
                    </div>
                  </div>
                  <div className="job-title-skills" style={{justifyContent: 'flex-start'}}>
                    {jobData?.employee_details?.skills && jobData?.employee_details?.skills.split(',').map((skill, index) => (
                      <span key={index} className="skill-tag">
                        {skill.trim()}
                      </span>
                    ))}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
       
        {/* <div className="text-right ratings">
          <h3>Leave rating</h3> 
          <Rating 
            key={rating} 
            onClick={handleRating} 
            initialValue={Number(rating) || 0} 
            ratingValue={Number(rating) || 0}
            allowFraction={false} 
            size={25}
            fillColor="#f57e1f"
            emptyColor="#cccccc"
            minimumValue={1}
          />
        </div> */}

                    <div className="profile-detail yorself">
                      <div className="row">
                        <div className="col-md-1 padding-0">
                          <a href="#!" className="profile-avatar">
                            <img src="/assets/images/term-payment.png" />
                          </a>
                        </div>
                        <div className="col-md-11 padding-0">
                          <ul>
                            <li>
                              <h6> {jobData?.bid_payment_term} </h6>
                              <h2>
                                <img
                                  src="/assets/images/rupee-blue.png"
                                  className="rupee"
                                />{" "}
                                <span>
                                  {" "}
                                  {jobData?.bid_amount} /-
                                </span>
                              </h2>
                              <p> {jobData?.budjet} </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div>
                      {jobData.job_plan?.is_premium === "0" ? (
                        jobData?.payment_milestone && jobData?.payment_milestone.length > 0 ? jobData?.payment_milestone?.map((value, index) => {
                          const getButtonText = (status, employeeMilestoneStatus = null) => {
                            switch (status) {
                              case "Completed":
                                return employeeMilestoneStatus === "Start" ? "Awaiting work start" : "Complete Work";
                              default:
                                return status;
                            }
                          };
                          const isDisabled = value.employee_milestone_status === "Start";
                          return (
                            <React.Fragment key={index}>
                              {value.employer_milestone_status !== "Payment Funded" ? (
                                <button
                                  className={`fws-milestone-action-btn ${isDisabled ? 'disabled' : ''}`}
                                  disabled={isDisabled}
                                  style={{width: '100%'}}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (isDisabled) return;
                                    if (value.employer_milestone_status === "Completed") {
                                      updateStatus(
                                        jobData?.id,
                                        value.name,
                                        "Completed",
                                        value.amount,
                                        value.milestone_id ? value.milestone_id : null
                                      );
                                    } 
                                  }}
                                >
                                  {getButtonText(value.employer_milestone_status, value.employee_milestone_status)}
                                </button>
                              ) : <p style={{width: '100%', textAlign: 'center'}}>Job Completed on {jobData.updated_at}</p>}
                            </React.Fragment>
                          );
                        }) : (
                          <div className="fws-no-milestones">
                            <p>No payment milestones available for this job.</p>
                          </div>
                        )
                      ) : (
                        jobData?.payment_milestone && jobData?.payment_milestone.length > 0 ? jobData?.payment_milestone?.map((value, index) => {
                          const getButtonText = (status, employeeMilestoneStatus = null) => {
                            switch (status) {
                              case "Escrow": return "Pay Escrow";
                              case "Completed":
                                return employeeMilestoneStatus === "Start" ? "Awaiting work start" : employeeMilestoneStatus === "Completed" ? "Await Completion" : "Mark as Complete";
                              case "Release Fund":
                                return "Release Fund";
                              case "Payment Funded":
                                return "Payment Funded";
                              default:
                                return status;
                            }
                          };

                          const getStatusText = (status, employeeMilestoneStatus = null) => {
                            const isWaitingForPrevious = isCurrentMilestoneDisabled() && index > 0;

                            if (isWaitingForPrevious) {
                              return `Waiting for previous ${jobData?.bid_payment_term === "By Milestone" ? "Milestone" : "Term"} to complete`;
                            }

                            switch (status) {
                              case "Escrow": return "Secured advance payment to start the work";
                              case "Completed":
                                return employeeMilestoneStatus === "Start" ? "Job Worker can start work" : employeeMilestoneStatus === "Completed" ? "Job Worker is working" : "Review & Confirm completion";
                              case "Release Fund":
                                return "Awaiting Payment Request";
                              case "Payment Funded": return jobData?.bid_payment_term === "By Completion" ? "Payment released & Completed" : `Payment released & ${jobData?.bid_payment_term === "By Milestone" ? "Milestone" : "Term"} ${index + 1} Completed`;
                              default:
                                return status;
                            }
                          };

                          const isCurrentMilestoneDisabled = () => {
                            if (index === 0) {
                              return false;
                            }

                            const previousMilestone = jobData?.payment_milestone[index - 1];

                            const previousMilestoneCompleted = previousMilestone &&
                              previousMilestone.employer_milestone_status === "Payment Funded" &&
                              previousMilestone.employee_milestone_status === "Payment Received";

                            return !previousMilestoneCompleted;
                          };

                          const isDisabled = (value.employer_milestone_status === "Completed" &&
                            (value.employee_milestone_status === "Start" || value.employee_milestone_status === "Completed"))
                            || (value.employer_milestone_status === "Release Fund" && value.employee_milestone_status === "Request To Pay")
                            || isCurrentMilestoneDisabled();
                          return (
                            <div 
                              className="fws-milestone-card" 
                              key={index} 
                              data-status={value.employer_milestone_status.toLowerCase().replace(' ', '-')}
                            >
                              <div className="fws-milestone-header">
                                <div className="fws-milestone-title">
                                  {jobData?.bid_payment_term === "By Milestone"
                                    ? `Milestone ${String(index + 1).padStart(2, '0')}`
                                    : jobData?.bid_payment_term === "By Terms"
                                      ? `Term ${String(index + 1).padStart(2, '0')}`
                                      : value.name}
                                </div>
                                <div className="fws-milestone-amount">
                                  ₹{typeof value.amount === 'number' ? Math.round(value.amount) : value.amount} {value.terms_percentage && `(${value.terms_percentage})`}
                                </div>
                              </div>

                              <div className="fws-milestone-description">
                                {jobData?.bid_payment_term === "By Milestone"
                                  ? value.milestone_descriction || value.name
                                  : jobData?.bid_payment_term === "By Terms"
                                    ? (index === 0 ? "Project Initiation & Setup"
                                      : index === 1 ? "Execution & Implementation"
                                        : "Review & Submission")
                                    : jobData?.bid_payment_term === "By Completion"
                                      ? "Complete Work"
                                      : value.milestone_descriction || value.name}
                              </div>

                              <div className="fws-milestone-separator"></div>

                              <div className="fws-milestone-footer">
                                <div className="fws-milestone-status">
                                  {value.employer_milestone_status !== "Payment Funded" ? <span className="fws-status-bullet"></span> : <img src={TermFinishedIcon} className="fws-status-img" />}
                                  <span className="fws-status-text">
                                    {getStatusText(value.employer_milestone_status, value.employee_milestone_status)}
                                  </span>
                                </div>
                                {value.employer_milestone_status !== "Payment Funded" && (
                                  <button
                                    className={`fws-milestone-action-btn ${isDisabled ? 'disabled' : ''}`}
                                    disabled={isDisabled}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (isDisabled) return;
                                      if (value.employer_milestone_status === "Escrow") {
                                        updateStatus(
                                          jobData?.id,
                                          value.name,
                                          "Completed",
                                          value.amount,
                                          value.milestone_id ? value.milestone_id : null
                                        );
                                      } else if (value.employer_milestone_status === "Completed") {
                                        updateStatus(
                                          jobData?.id,
                                          value.name,
                                          "Release Fund",
                                          value.amount,
                                          value.milestone_id ? value.milestone_id : null
                                        );
                                      } else if (value.employer_milestone_status === "Release Fund") {
                                        updateStatus(
                                          jobData?.id,
                                          value.name,
                                          "Payment Funded",
                                          value.amount,
                                          value.milestone_id ? value.milestone_id : null
                                        );
                                      }
                                    }}
                                  >
                                    {getButtonText(value.employer_milestone_status, value.employee_milestone_status)}
                                  </button>
                                )}
                              </div>
                            </div>
                          );
                        }) : (
                          <div className="fws-no-milestones">
                            <p>No payment milestones available for this job.</p>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                  <Loader loading={loading} />
                </LoadingOverlay>
              </section>
            </div>
          </div>
        </div>
      </div>
      {/* <Modal
        isOpen={mapView}
        onRequestClose={() => setMapView(false)}
        style={customStyles}
        contentLabel="Example Modal"
        scrollable={true}
      >
        <div className="modal-dialog loginpopup" role="document">
          <div className="modal-content">
            <div>
              <div className="modal-header">
                <h5 className="modal-title">
                View Location on Map
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setMapView(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <GoogleMapReact
                  style={{ height: 400 }}
                  bootstrapURLKeys={{
                    key: process.env.REACT_APP_GOOGLE_LOCATION_API_KEY,
                  }}
                  defaultCenter={{
                    lat: parseFloat(jobData?.latitude),
                    lng: parseFloat(jobData?.longitude),
                  }}
                  defaultZoom={11}
                >
                  <MarkerComponent text="My Marker" />
                </GoogleMapReact>
              </div>
            </div>
          </div>
        </div>
      </Modal> */}

<Modal
  isOpen={ratingView}
  onRequestClose={() => {
    setRatingView(false);
    setComment("");
    setSelectedRating(0);
  }}
  style={customStyles}
  contentLabel="Rating Modal"
  scrollable={true}
>
  <div className="modal-dialog loginpopup" role="document" style={{ maxWidth: '500px', margin: '50px auto', zIndex: 1001 }}>
    <div className="modal-content" style={{ borderRadius: '12px', overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.15)', position: 'relative', zIndex: 1002 }}>
      <div>
        <div className="modal-header" style={{ 
          background: '#1e3a5f', 
          color: 'white', 
          padding: '20px', 
          borderBottom: 'none',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <h5 className="modal-title" style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
            <span>Leave Your Rating</span>
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              setRatingView(false);
              setComment("");
              setSelectedRating(0);
              window.location.href = "/mycontracts"
            }}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'white',
              fontSize: '28px',
              cursor: 'pointer',
              padding: '0',
              width: '30px',
              height: '30px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              opacity: 0.8
            }}
            onMouseEnter={(e) => e.target.style.opacity = '1'}
            onMouseLeave={(e) => e.target.style.opacity = '0.8'}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div className="modal-body" style={{ 
          padding: '30px', 
          paddingBottom: '20px',
          background: 'white',
          position: 'relative',
          zIndex: 1002
        }}>
                <div style={{
                  padding: '30px 0',
                  marginBottom: '30px',
                  background: '#f8f9fa',
                  borderRadius: '8px'
                }}>
                  {selectedRating < 1 && (
                    <div style={{
                      textAlign: 'center',
                      marginBottom: '15px',
                      paddingTop: '10px'
                    }}>
                      <span style={{
                        color: '#dc3545',
                        fontSize: '14px',
                        fontWeight: '500'
                      }}>
                        Please select at least one star.
                      </span>
                    </div>
                  )}

                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginBottom: '10px'
                  }}>
                    <Rating
                      onClick={(rate) => {
                        const finalRate = Math.max(1, rate);
                        setSelectedRating(finalRate);
                      }}
                      initialValue={selectedRating}
                      ratingValue={selectedRating}
                      allowFraction={false}
                      size={40}
                      fillColor="#f57e1f"
                      emptyColor="#e0e0e0"
                      minimumValue={1}
                      transition={true}
                    />
                  </div>

                  {selectedRating > 0 && (
                    <div style={{
                      textAlign: 'center',
                      marginTop: '10px'
                    }}>
                      <span style={{
                        color: '#333',
                        fontSize: '16px',
                        fontWeight: '600',
                        fontStyle: 'italic'
                      }}>
                        {getRatingLabel(selectedRating)}
                      </span>
                    </div>
                  )}
                </div>

          <div style={{ marginBottom: '25px', position: 'relative', zIndex: 1003 }}>
            <label style={{
              display: 'block',
              marginBottom: '10px',
              fontWeight: '500',
              color: '#333',
              fontSize: '15px'
            }}>
              Comment (Optional)
            </label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              placeholder="Share your experience..."
              rows="5"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                border: '2px solid #ddd',
                borderRadius: '8px',
                fontFamily: 'inherit',
                fontSize: '14px',
                resize: 'vertical',
                boxSizing: 'border-box',
                outline: 'none',
                transition: 'border-color 0.3s',
                pointerEvents: loading ? 'none' : 'auto',
                zIndex: 1003,
                position: 'relative',
                background: loading ? '#f5f5f5' : 'white'
              }}
              onFocus={(e) => {
                if (!loading) {
                  e.target.style.borderColor = '#f57e1f';
                  e.target.style.boxShadow = '0 0 0 3px rgba(245, 126, 31, 0.1)';
                }
              }}
              onBlur={(e) => {
                e.target.style.borderColor = '#ddd';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          <div style={{
            display: 'flex',
            gap: '12px',
            justifyContent: 'flex-end',
            paddingTop: '20px',
            borderTop: '1px solid #e0e0e0'
          }}>
            <button
              onClick={() => {
                setRatingView(false);
                setComment("");
                setSelectedRating(0);
                window.location.href = "/mycontracts"
              }}
              disabled={loading}
              style={{
                padding: '12px 24px',
                borderRadius: '8px',
                border: '1px solid #ddd',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                background: '#f8f9fa',
                color: '#333',
                opacity: loading ? 0.5 : 1,
                transition: 'all 0.3s',
                minWidth: '100px'
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.target.style.background = '#e9ecef';
                  e.target.style.borderColor = '#ccc';
                }
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#f8f9fa';
                e.target.style.borderColor = '#ddd';
              }}
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={loading || selectedRating === 0}
              style={{
                padding: '12px 24px',
                borderRadius: '8px',
                border: 'none',
                cursor: (loading || selectedRating === 0) ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '600',
                background: selectedRating === 0 ? '#ccc' : '#f57e1f',
                color: 'white',
                opacity: loading ? 0.7 : 1,
                transition: 'all 0.3s',
                minWidth: '140px',
                boxShadow: selectedRating > 0 ? '0 2px 8px rgba(245, 126, 31, 0.3)' : 'none'
              }}
              onMouseEnter={(e) => {
                if (!loading && selectedRating !== 0) {
                  e.target.style.background = '#d96d17';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(245, 126, 31, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                e.target.style.background = selectedRating === 0 ? '#ccc' : '#f57e1f';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = selectedRating > 0 ? '0 2px 8px rgba(245, 126, 31, 0.3)' : 'none';
              }}
            >
              {loading ? "Submitting..." : "Submit Rating"}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</Modal>

      <Modal
        isOpen={msgPopup}
        onRequestClose={() => setMsgPopup(false)}
        style={customStyles}
        contentLabel="Example Modal"
        scrollable={true}
      >
        <div className="modal-dialog loginpopup" role="document">
          <div className="modal-content">
            <div>
              <div className="modal-header">
                <h5 className="modal-title">
                   <span>GigFWS</span> 
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setMsgPopup(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body" style={{paddingBottom: '30px'}}>
        <h5 className="mobile-nuber-sec">It would be grateful if you reach me at <span>{mobile}</span> number.</h5>
      </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* <Modal
        isOpen={ratingView}
        onRequestClose={() => setRatingView(false)}
        style={customStyles}
        contentLabel="Example Modal"
        scrollable={true}
      >
        <div className="modal-dialog loginpopup" role="document">
          <div className="modal-content">
            <div>
              <div className="modal-header">
                <h5 className="modal-title">
                   <span>Rating</span> 
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setRatingView(false)}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body" style={{paddingBottom: '30px'}}>
              <Rating 
                key={rating}
                onClick={handleRating} 
                initialValue={Number(rating) || 0} 
                ratingValue={Number(rating) || 0}
                allowFraction={false} 
                size={25}
                fillColor="#f57e1f"
                emptyColor="#cccccc"
                minimumValue={1}
              />
                    </div>
            </div>
          </div>
        </div>
      </Modal> */}
      {isOpen && (
        <NewWindow close={close}>
          Example <button onClick={close}>Close</button>
        </NewWindow>
      )}
      
      <ProfilePopup 
        isOpen={showProfilePopup}
        onClose={closeProfilePopup}
        userData={selectedUserData}
      />
    </section>
  );
};
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "500px",
    height: "auto",
    background: "transparent",
    border: "none",
    padding: "0",
    zIndex: 1000
  },
  overlay: { 
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AwardedJobDetailView);
